import React from "react"
import { Dialog, FlatButton, Table, TableRow, TableBody, TableRowColumn, TableHeader, TableHeaderColumn } from "material-ui"
import strings from "../../localization/strings"
import { IFailedCalcAccrualDataInfoDialogContent } from "../../models"
import * as payrollActions from "../../actions/PayrollActions"
interface IProps {
    content: IFailedCalcAccrualDataInfoDialogContent[]
    close(): void
}

const FailedCalcAccrualDataInfoDialog: React.SFC<IProps> = (props: IProps) => {
    let failedCalcAccrualEmployees = []
    props.content.forEach(i => {
        failedCalcAccrualEmployees = failedCalcAccrualEmployees.concat(i.RecalcAccrualData)
    })
    if (failedCalcAccrualEmployees.length === 0) return null
    return (
        <Dialog
            modal
            open
            autoScrollBodyContent
            title={strings.Failed_Calculate_Accural_Employees_For_Close_Payroll}
            actions={[
                <FlatButton
                    data-intercom-target={"Btn-FailedCalcAccrualDataInfoDialog-Close"}
                    label={strings.Close}
                    secondary
                    onTouchTap={props.close}
                />,
                <FlatButton
                    data-intercom-target={"Btn-FailedCalcAccrualDataInfoDialog-Recalculate"}
                    label={strings.Recalculate}
                    primary
                    keyboardFocused
                    onClick={() => {
                        props.close()
                        payrollActions.recalcFailedAccrual(props.content.map(i => i.PayrollStatusDocId))
                    }}
                />
            ]}
            onRequestClose={props.close}
        >
            <Table selectable={false}>
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    enableSelectAll={false}
                >
                    <TableRow style={{ height: 40 }}>
                        <TableHeaderColumn style={{ height: 40, width: 150 }}> {strings.Name}</TableHeaderColumn>
                        <TableHeaderColumn style={{ height: 40 }}>{strings.Error}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                    {failedCalcAccrualEmployees.map(i =>
                        <TableRow key={i.UserId} style={{ height: 30, borderBottom: "none" }}>
                            <TableRowColumn style={{ height: 30, width: 150 }}>{i.UserName}</TableRowColumn>
                            <TableRowColumn style={{ height: 30 }}>{i.FailedMsg}</TableRowColumn>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Dialog>
    )
}

export default FailedCalcAccrualDataInfoDialog